export const PENDING_EDIT_REQUEST_STATUS_PENDING = 0;
export const PENDING_EDIT_REQUEST_STATUS_APPROVED = 1;
export const PENDING_EDIT_REQUEST_STATUS_REJECTED = 2;